import RESTSerializer from '@ember-data/serializer/rest';

export default class DeepDiveGreenOptionOrderSerializer extends RESTSerializer {}

declare module 'ember-data/types/registries/serializer' {
  export default interface SerializerRegistry {
    'deep-dive/green-option/order': DeepDiveGreenOptionOrderSerializer;
  }
}
